export const EMPLOYMENT_OPTIONS = [
  { value: "privateEmployee", label: "Private Employee" },
  { value: "govtEmployee", label: "Government Employee" },
  { value: "business", label: "Business" },
  { value: "notWorking", label: "Not working" },
  { value: "student", label: "Student" },
];

export const getEmploymentLabel = (value: string) =>
  EMPLOYMENT_OPTIONS.find((option) => option.value === value)?.label || value;
